import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UigNewsAdapter } from "./uig-news.adapter";
import { UigNewsItem } from "./uig-news.model";

@Injectable({
  providedIn: "root",
})
export class UigNewsConnector {
  constructor(protected adapter: UigNewsAdapter) {}

  getNews(): Observable<UigNewsItem[]> {
    return this.adapter.getNews();
  }
}
